import { RemoteData } from '@common/util-models';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IMEIValidateAPIResultItem, IMEIStatusEnum } from '@sky/util-models';
import { ImeiState, IMEI_FEATURE_KEY } from './imei.reducer';

export const getImeiState = createFeatureSelector<ImeiState>(IMEI_FEATURE_KEY);

export const getImeiLoaded = createSelector(
  getImeiState,
  (state: ImeiState) => state.remoteState
);

export const isImeiInvalid = createSelector(
  getImeiLoaded,
  (imeiLoaded: RemoteData): boolean =>
    imeiLoaded.kind === 'error' &&
    (imeiLoaded.error.name === IMEIStatusEnum.Invalid ||
      imeiLoaded.error.name === IMEIStatusEnum.NotFound)
);

export const getImeiApiResult = createSelector(
  getImeiState,
  (state: ImeiState) => state.imeiApiResult
);

export const getImeiBrand = createSelector(
  getImeiApiResult,
  (imeiApiResult: IMEIValidateAPIResultItem | undefined): string | undefined =>
    imeiApiResult?.manufacturerBrandDescription
);

export const getImeiModel = createSelector(
  getImeiApiResult,
  (imeiApiResult: IMEIValidateAPIResultItem | undefined): string | undefined =>
    imeiApiResult?.models[0].name
);

export const getImeiNumber = createSelector(
  getImeiApiResult,
  (imeiApiResult: IMEIValidateAPIResultItem | undefined): string | undefined =>
    imeiApiResult?.serials[0]
);
